/** Ouvre l’écran Google ou Facebook hors de l’iframe du hub. */
export function openOAuthUrl(url: string): void {
  let embedded = false;
  try {
    embedded = window.parent !== window;
  } catch {
    embedded = true;
  }
  if (!embedded) {
    window.location.assign(url);
    return;
  }
  const popup = window.open(url, "presence-oauth");
  if (!popup) throw new Error("popup_blocked");
  popup.focus();
}

export type OAuthReturn = {
  type: "presence-oauth";
  google: string | null;
  facebook: string | null;
  reason: string | null;
  pages: string | null;
};

export function notifyOAuthOpener(params: URLSearchParams): void {
  if (!params.has("google") && !params.has("facebook")) return;
  if (!window.opener || window.opener === window) return;
  const data: OAuthReturn = {
    type: "presence-oauth",
    google: params.get("google"),
    facebook: params.get("facebook"),
    reason: params.get("reason"),
    pages: params.get("pages"),
  };
  try {
    window.opener.postMessage(data, window.location.origin);
    window.close();
  } catch {
    /* la fenêtre reste ouverte si le navigateur refuse de la fermer */
  }
}

export function isOAuthReturn(data: unknown): data is OAuthReturn {
  if (!data || typeof data !== "object") return false;
  return (data as { type?: string }).type === "presence-oauth";
}
